import { Check, X } from "lucide-react";
import { Reveal } from "./Reveal";

const traditional = [
  "Typing during appointments",
  "Spending hours charting",
  "Incomplete documentation",
  "Manual formatting",
  "Less patient interaction",
];

const palnote = [
  "AI-generated SOAP notes",
  "Complete documentation assistance",
  "Faster chart completion",
  "Professional formatting",
  "More time focused on patient care",
];

export function WhyPalNote() {
  return (
    <section className="bg-white py-24">
      <div className="mx-auto max-w-6xl px-5 sm:px-8">
        <Reveal className="mx-auto max-w-2xl text-center">
          <span className="text-sm font-semibold uppercase tracking-wider text-blue-600">
            Why PalNote
          </span>
          <h2 className="mt-3 text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl">
            A better way to document care
          </h2>
        </Reveal>

        <div className="mt-14 grid gap-6 md:grid-cols-2">
          <Reveal>
            <div className="h-full rounded-3xl border border-slate-200 bg-slate-50/70 p-8">
              <h3 className="text-lg font-semibold text-slate-500">Traditional Documentation</h3>
              <ul className="mt-6 space-y-4">
                {traditional.map((item) => (
                  <li key={item} className="flex items-start gap-3">
                    <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-red-100 text-red-500">
                      <X className="h-3.5 w-3.5" />
                    </span>
                    <span className="text-sm text-slate-600">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>

          <Reveal delay={0.12}>
            <div className="relative h-full overflow-hidden rounded-3xl border border-blue-200 bg-gradient-to-b from-blue-50 to-white p-8 shadow-xl shadow-blue-900/5">
              <div className="absolute right-6 top-6 rounded-full bg-blue-600 px-3 py-1 text-xs font-semibold text-white">
                PalNote
              </div>
              <h3 className="text-lg font-semibold text-slate-900">With PalNote</h3>
              <ul className="mt-6 space-y-4">
                {palnote.map((item) => (
                  <li key={item} className="flex items-start gap-3">
                    <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-emerald-100 text-emerald-600">
                      <Check className="h-3.5 w-3.5" />
                    </span>
                    <span className="text-sm font-medium text-slate-700">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
